import { Reducer } from 'react'
import { PaymentState, PaymentEvent } from './types'

export const paymentStateReducer: Reducer<PaymentState, PaymentEvent> = (
  state,
  event
) => {
  switch (event.type) {
    case 'CREATE_TRANSACTION': {
      if (state.status !== 'cancelled') return state
      return {
        status: 'creatingTransaction',
      }
    }
    case 'START_POLLING': {
      return {
        status: 'polling',
        paymentIntentId: event.paymentIntentId,
      }
    }
    case 'POLL_RESULT_OK': {
      if (
        !['creatingTransaction', 'polling', 'recovering', 'cancelled'].includes(
          state.status
        )
      )
        return state

      // For automatic capture, we can just go to done
      return {
        status: 'done',
        transaction: event.transaction,
      }
    }
    case 'CANCELLED': {
      return {
        status: 'cancelled',
        errorMessage: event.errorMessage,
        previousState: state,
        paymentIntentId: event.paymentIntentId,
        reason: event.reason,
      }
    }
    case 'AUTHORISED': {
      if (
        !['creatingTransaction', 'polling', 'recovering', 'cancelled'].includes(
          state.status
        )
      )
        return state
      // for manual capture
      return {
        status: 'capturing',
        paymentIntentId: event.paymentIntentId,
      }
    }
    case 'CAPTURE_OK': {
      if (state.status !== 'capturing') return state
      return {
        status: 'done',
        transaction: event.transaction,
      }
    }
    case 'ERROR': {
      return {
        status: 'error',
        errorMessage: event.errorMessage,
        previousState: state,
        swiperError: event.swiperError,
        disableRetry: event.disableRetry,
      }
    }
    case 'DECLINED': {
      return {
        status: 'declined',
        errorMessage: event.errorMessage,
        previousState: state,
        paymentIntentId: event.paymentIntentId,
      }
    }
    case 'RETRY': {
      return event.previousState
    }
    default: {
      // This `never` typing will let us know at compile time if we do not handle an existing event type. Neat !
      const _exhaustiveCheck: never = event
      return _exhaustiveCheck
    }
  }
}
